import { LOAD_USER_ORDERS, CREATE_ORDER } from './type'
import firebase, { firestore } from '../utils/firebase'

export const loadUserOrders = () => (dispatch, getState) => {
    const uid = getState().user.uid
    firestore.collection('orders').where('uid', '==', uid).orderBy('orderedAt', 'desc').onSnapshot(snapshot => {
        const orders = {}
        const liveOrders = []
        const pastOrders = []

        snapshot.forEach(doc => {
            // console.log(doc);
            orders[doc.id] = {
                id: doc.id,
                ...doc.data()
            }

            const { orderLive } = doc.data()

            if (orderLive) {
                liveOrders.push(doc.id)
            } else {
                pastOrders.push(doc.id)
            }

        })

        dispatch({
            type: LOAD_USER_ORDERS,
            payload: {
                orders,
                liveOrders,
                pastOrders
            }
        })
    })
}

export const createOrder = (data) => dispatch => {

    firestore.collection('orders').add({
        ...data,
        orderedAt: firebase.firestore.FieldValue.serverTimestamp()
    }).then(() => {

        firestore.collection('user').doc(data.uid).update({
            cart: {}
        })

        dispatch({
            type: CREATE_ORDER
        })
        window.location.href = "/live-orders"
    })
}